import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";
import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDOPUnrHZlzW1kvna-8QYQi03CulrfD4as",
  authDomain: "flutter-chat-app-e4b52.firebaseapp.com",
  projectId: "flutter-chat-app-e4b52",
  storageBucket: "flutter-chat-app-e4b52.firebasestorage.app",
  messagingSenderId: "221033557555",
  appId: "1:221033557555:web:aadac8890c91adf0463d46",
  measurementId: "G-8STHW9W4VR"
};

if (typeof window !== "undefined" && process.env.NODE_ENV === 'development') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true; 
}

const app = initializeApp(firebaseConfig);

if (typeof window !== "undefined") {
  // We check for 'window' to ensure this only runs in the browser
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider('6Ld6yLYsAAAAADmlvXzX5lxz-9rQMPX-nHXx6d0-'),
    isTokenAutoRefreshEnabled: true, // Automatically refresh the token in the background
  });
}


const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const vertexAI = getAI(app, { backend: new GoogleAIBackend() });

// Remote Config
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 0; // 0 for testing/immediate fetch
remoteConfig.defaultConfig = {
  founderMode: false, // Safe default: don't grant founder status if fetch fails
  ads_enabled_web: false,
};

// Export the database instance
export { auth, db, storage, vertexAI, getGenerativeModel, remoteConfig, fetchAndActivate, getValue };

export const messaging = getMessaging(app);
